import React, { useEffect, useRef } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { Paper } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GaugeChart from "react-gauge-chart";
import ProgressBar from "@ramonak/react-progress-bar";
import { IMAGE_URL } from "network";
import { useGetScanReportQuery } from "slices/skin/scanSlice";

function Report({ datattt, open, onClose }) {
  const sliderRef = useRef(null);
  const { data: initialData, isLoading: isLoadingInitial } =
    useGetScanReportQuery(datattt?._id, {
      skip: !open || !datattt?._id,
    });

  console.log("datattt", datattt, initialData);

  if (!open) return null;

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 5 } },
      { breakpoint: 600, settings: { slidesToShow: 3 } },
    ],
  };

  const sliderProductSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
    ],
  };

  const progressColor = (val) => {
    if (val > 80) return "bg-danger";
    if (val > 50) return "bg-warning";
    return "bg-success";
  };

  // const progressColor =
  //   "linear-gradient(to right, #4CAF50, #CDDC39, #FFC107, #FF5722, #F44336)";

  const progressGradient =
    "linear-gradient(to right, #4CAF50, #CDDC39, #FFC107, #FF5722, #F44336)";

  return (
    <>
      {/* Overlay */}
      <div
        className="modal fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 9999,
        }}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          // style={{ maxWidth: "700px" }}
        >
          <div
            className="modal-content p-4"
            style={{ background: "#fff5f8", borderRadius: "15px" }}
          >
            {/* Close Button */}
            <div
              className="position-absolute top-0 end-0 p-2"
              style={{ cursor: "pointer", zIndex: 10 }}
              onClick={onClose}
            >
              <CancelIcon />
            </div>

            {/* Top Profile + Score Box */}
            <div
              className="row align-items-center p-3"
              style={{ background: "#fff", borderRadius: "15px" }}
            >
              {/* Profile */}
              <div className="col-md-4 text-center">
                <img
                  crossOrigin="anonymous"
                  src={IMAGE_URL + datattt.image}
                  alt={datattt.image}
                  className="rounded-circle"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                  }}
                />
                <h6 className="mt-2 text-capitalize">{datattt.name}</h6>

                <div
                  className="position-relative d-inline-block"
                  style={{ marginTop: "10px" }}
                >
                  <GaugeChart
                    id="gauge-chart2"
                    nrOfLevels={20}
                    percent={datattt.skinScore / 100} // 14.5 / 100
                    arcPadding={0.01}
                    colors={["#FF2E2E", "#FFBF00", "#00FF00"]}
                    cornerRadius={2}
                    arcWidth={0.2}
                    needleColor="#444"
                    needleBaseColor="#444"
                    textColor="#000"
                    style={{ width: "180px" }}
                  />
                </div>

                {/* <img src="/gauge.png" alt="gauge" style={{ width: "120px" }} />
                <p className="fw-bold">{data.score}%</p> */}
              </div>

              {/* Score Info */}
              <div
                className="col-md-8"
                style={{
                  background: "#ffe6ef",
                  borderRadius: "10px",
                  padding: "15px",
                }}
              >
                <h5 className="fw-bold">Your Skin Score</h5>
                <h3 className="text-success fw-bold">
                  {datattt.skinScore} / 100
                </h3>
                <p className="mt-0 mb-0">
                  <strong>Gender:</strong> {datattt.gender}
                </p>
                <p className="mt-0 mb-0">
                  <strong>Email:</strong> {datattt.email}
                </p>
                <p className="mt-0 mb-0">
                  <strong>Phone:</strong> {datattt.phone}
                </p>
                <p className="mt-0 mb-0">
                  <strong>Primary Concern:</strong> {datattt.skinTypeConcern}
                </p>
                <p className="mt-0 mb-0">
                  <strong>Skin Type:</strong> {datattt.skinType}
                </p>
                <p className="mt-0 mb-0">
                  <strong>Skin Type Confidence:</strong>{" "}
                  {datattt.skinTypeConfidence}
                </p>
              </div>
            </div>

            <Slider ref={sliderRef} {...sliderSettings}>
              {datattt.concerns.map((item, i) => {
                // Default gradient
                let progressColor =
                  "linear-gradient(to right, #F44336, #FF5722, #FFC107, #CDDC39, #4CAF50)";

                if (item.severity?.toLowerCase() === "high") {
                  // light red to dark red
                  progressColor =
                    "linear-gradient(to right, #FFCDD2, #EF5350, #B71C1C)";
                } else if (item.severity?.toLowerCase() === "low") {
                  // light green to dark green
                  progressColor =
                    "linear-gradient(to right, #C8E6C9, #66BB6A, #1B5E20)";
                } else if (item.severity?.toLowerCase() === "not present") {
                  // yellow to orange to red
                  progressColor =
                    "linear-gradient(to right, #FFF9C4, #FFB74D, #F44336)";
                }

                return (
                  <div className="dark-circle ">
                    <div className="dark d-flex align-items-start gap-2">
                      <div className="card-box new-card" key={i}>
                        <div className="percentage">{item.percentage} % </div>
                        <ProgressBar
                          completed={item.percentage}
                          bgColor={progressColor} // gradient background
                          height="14px"
                          labelAlignment="outside"
                          labelColor="#111"
                          borderRadius="8px"
                          animateOnRender
                        />
                        <div className="label">{item.name}</div>
                      </div>
                      <div className="dark-right">
                        {item?.info?.description && (
                          <span className="spcl">
                            Specialiest <i class="bi bi-check2-circle"></i>
                          </span>
                        )}
                        <h5>{item.name}</h5>
                        {item?.info?.description ? (
                          <>
                            <p>
                              {item?.info?.description?.length > 150
                                ? `${item.info.description.substring(
                                    0,
                                    150
                                  )}...`
                                : item.info.description}
                            </p>
                          </>
                        ) : (
                          <p>
                            Wellness is an active, holistic approach to being
                            healthy in body, mind, and spirit
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>

            {/* Recommended Products */}
            {initialData?.recommendations?.products?.length > 0 && (
              <>
                <h4 className="text-center mt-4 mb-3 fw-bold">
                  Luxe Premium Rituals
                </h4>

                <div className="row g-3">
                  <Slider ref={sliderRef} {...sliderProductSettings}>
                    {initialData?.recommendations?.products.map((prod, idx) => (
                      <div key={idx} className="col-md-4 text-center">
                        <img
                          crossOrigin="anonymous"
                          src={IMAGE_URL + prod.image}
                          alt={prod.name}
                          className="rounded"
                          style={{
                            width: "100%",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                        <p className="mt-2 fw-semibold">{prod.name}</p>
                      </div>
                    ))}
                  </Slider>
                </div>
              </>
            )}

            {/* Recommended Services */}
            {initialData?.recommendations?.services?.length > 0 && (
              <>
                <h4 className="text-center mt-4 mb-3 fw-bold">
                  Recommended Services
                </h4>

                <div className="row g-3">
                  <Slider ref={sliderRef} {...sliderProductSettings}>
                    {initialData?.recommendations?.services.map((prod, idx) => (
                      <div key={idx} className="col-md-4 text-center">
                        <img
                          crossOrigin="anonymous"
                          src={IMAGE_URL + prod.thumbnail}
                          alt={prod.name}
                          className="rounded"
                          style={{
                            width: "100%",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                        <p className="mt-2 fw-semibold">{prod.name}</p>
                      </div>
                    ))}
                  </Slider>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Report;
